import Vue from 'vue'
import Router from 'vue-router'


// 艺术品档案
const routersContextArtworkArchive = require.context('@/pages/artworkArchive', true, /router_artworkArchive\.js$/)
const routersArrayArtworkArchive = routersContextArtworkArchive.keys().map(key => routersContextArtworkArchive(key).default)

// 运营管理
const routersContextDevOpsManage = require.context('@/pages/devOpsManage', true, /router_devOpsManage\.js$/)
const routersArrayDevOpsManage = routersContextDevOpsManage.keys().map(key => routersContextDevOpsManage(key).default)

// 财务管理
const routersContextFinanceManage = require.context('@/pages/financeManage', true, /router_financeManage\.js$/)
const routersArrayFinanceManage = routersContextFinanceManage.keys().map(key => routersContextFinanceManage(key).default)

// 权限管理
const routersContextAuthManage = require.context('@/pages/authManage', true, /router_authManage\.js$/)
const routersArrayAuthManage = routersContextAuthManage.keys().map(key => routersContextAuthManage(key).default)

// 版本管理
const routersContextVersionManage = require.context('@/pages/versionManage', true, /router_versionManage\.js$/)
const routersArrayVersionManage = routersContextVersionManage.keys().map(key => routersContextVersionManage(key).default)

// 版本日志
const routersContextVersionLog = require.context('@/pages/versionLog', true, /router_versionLog\.js$/)
const routersArrayVersionLog = routersContextVersionLog.keys().map(key => routersContextVersionLog(key).default)

// 消息中心
const routersContextMessageCenter = require.context('@/pages/messageCenter', true, /router_messageCenter\.js$/)
const routersArrayMessageCenter = routersContextMessageCenter.keys().map(key => routersContextMessageCenter(key).default)

// 系统日志
const routersContextSystemLog = require.context('@/pages/systemLog', true, /router_systemLog\.js$/)
const routersArraySystemLog = routersContextSystemLog.keys().map(key => routersContextSystemLog(key).default)

// 价值
const routersContextValueManage = require.context('@/pages/valueManage', true, /router\.js$/)
const routersArrayValueManage = routersContextValueManage.keys().map(key => routersContextValueManage(key).default)

// 动态
const routersContextDynamicManage = require.context('@/pages/dynamicManage', true, /router\.js$/)
const routersArrayDynamicManage = routersContextDynamicManage.keys().map(key => routersContextDynamicManage(key).default)

Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

const routers = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/pages/home/index')
  },
  {
    path: '',
    name: 'art_home',
    component: () => import('@/pages/home/index')
  },
  {
    path: '/index',
    name: 'index',
    component: () => import('@/pages/home/index')
  },
  {
    path: '/artworkArchive',
    name: 'artworkArchive',
    component: () => import('@/components/layout/layout-manage.vue'),
    redirect: '/artworkArchive/index',
    children: routersArrayArtworkArchive
  },
  {
    path: '/devOpsManage',
    name: 'devOpsManage',
    component: () => import('@/components/layout/layout-manage.vue'),
    redirect: '/devOpsManage/index',
    children: routersArrayDevOpsManage
  },
  {
    path: '/financeManage',
    name: 'financeManage',
    component: () => import('@/components/layout/layout-manage.vue'),
    redirect: '/financeManage/index',
    children: routersArrayFinanceManage
  },
  {
    path: '/authManage',
    name: 'authManage',
    component: () => import('@/components/layout/layout-manage.vue'),
    redirect: '/authManage/index',
    children: routersArrayAuthManage
  },
  // 版本管理
  {
    path: '/versionManage',
    name: 'versionManage',
    component: () => import('@/components/layout/layout-manage.vue'),
    redirect: '/versionManage/index',
    children: routersArrayVersionManage
  },
  // 版本日志
  {
    path: '/versionLog',
    name: 'versionLog',
    component: () => import('@/components/layout/layout-manage.vue'),
    redirect: '/versionLog/index',
    children: routersArrayVersionLog
  },
  // 系统日志
  {
    path: '/systemLog',
    name: 'systemLog',
    component: () => import('@/components/layout/layout-manage.vue'),
    redirect: '/systemLog/index',
    children: routersArraySystemLog
  },
  // 价值
  {
    path: '/valueManage',
    component: () => import('@/components/layout/layout-manage.vue'),
    redirect: '/valueManage/index',
    children: routersArrayValueManage
  },
  // 动态
  {
    path: '/dynamicManage',
    component: () => import('@/components/layout/layout-manage.vue'),
    redirect: '/dynamicManage/index',
    children: routersArrayDynamicManage
  },
  // 消息中心
  {
    path: '/messageCenter',
    name: 'messageCenter',
    component: () => import('@/components/layout/layout-manage.vue'),
    redirect: '/messageCenter/index',
    children: routersArrayMessageCenter
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/pages/account/login')
  },
  {
    path: '/loginFail',
    name: 'loginFail',
    component: () => import('@/pages/account/loginFail')
  },
  {
    // 链接页
    path: '/devOpsLinkPage',
    name: 'devOpsLinkPage',
    component: () => import('@/pages/devOpsLinkPage/index')
  },
  {
    path: '/art-data-center',
    name: 'artDataCenter',
    component: () => import('@/pages/artDataCenter'),
  },
  {
    path: '/test',
    name: 'test',
    component: () => import('@/pages/test')
  },
  {
    path: '*',
    name: 'page404',
    component: () => import('@/pages/page404')
  }
]
//console.log('window.env',window.apiConfig[window.env + 'Api'][1])
const router = new Router({
  //base: window.apiConfig[window.env + 'Api'][1] || '/',
  mode: 'history',
  routes: routers
})

// 处理push时控制台报错
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

// 处理replace时控制台报错
const VueRouterReplace = Router.prototype.replace
Router.prototype.replace = function replace (to) {
  return VueRouterReplace.call(this, to).catch(err => err)
}

// 路由跳转之后页面置顶
router.afterEach((to, from, next) => {
  setTimeout(() => {
    document.querySelector('#app').scrollTop = 0;
  })
}, 60)

// router.beforeEach((to, from, next) => {
//   let token = window.localStorage.getItem('art-x-auth-token')
//   let userInfo = window.localStorage.getItem('art-userInfo')
//   if (!token || !userInfo) {
//     if (to.path === '/login') { // 如果是登录页面路径，就直接next()
//       next()
//     } else {
//       next('/login')
//     }
//   } else {
//     next()
//   }
// })

// router.onError(error => {
//   const pattern = /Loading chunk (\d)+ failed/g
//   const isChunkLoadFailed = error.message.match(pattern)
//   if (isChunkLoadFailed) {
//     location.reload()
//   }
// })

export default router



// WEBPACK FOOTER //
// ./src/router/index.js